/**
 * Handles variant selection for inline upsell cards on PDP.
 *
 * This is intentionally NOT a <variant-selects> element. Because it does not
 * extend VariantSelects, the global optionValueSelectionChange pub/sub event
 * is never published. stopPropagation() is added as additional safety to
 * prevent the DOM change event from reaching any ancestor listeners.
 */
class UpsellInlineSelects extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.wrapper = this.closest('.collection-upsell__inline-add');

    this.addEventListener('change', (event) => {
      event.stopPropagation();
      this.onVariantChange();
    });
  }

  onVariantChange() {
    const selected = Array.from(
      this.querySelectorAll('fieldset input[type="radio"]:checked')
    ).map((input) => input.value);

    const variant = this.variants.find((v) =>
      selected.every((val, i) => v.options[i] === val)
    );

    if (!this.wrapper) return;

    const formInput = this.wrapper.querySelector('product-form input[name="id"]');
    const submitBtn = this.wrapper.querySelector('button[type="submit"]');

    if (!variant) {
      if (submitBtn) submitBtn.disabled = true;
      return;
    }

    if (formInput) {
      formInput.value = variant.id;
      formInput.disabled = !variant.available;
    }

    const priceEl = this.wrapper.querySelector('.collection-upsell__inline-price');
    if (priceEl) {
      priceEl.textContent = window.Shopify?.formatMoney
        ? Shopify.formatMoney(variant.price)
        : '$' + (variant.price / 100).toFixed(2);
    }

    if (submitBtn) {
      const btnText = submitBtn.querySelector('.btn-text');
      const soldOutMsg = submitBtn.querySelector('.sold-out-message');
      if (variant.available) {
        submitBtn.disabled = false;
        if (btnText) btnText.classList.remove('hidden');
        if (soldOutMsg) soldOutMsg.classList.add('hidden');
      } else {
        submitBtn.disabled = true;
        if (btnText) btnText.classList.add('hidden');
        if (soldOutMsg) soldOutMsg.classList.remove('hidden');
      }
    }
  }
}

customElements.define('upsell-inline-selects', UpsellInlineSelects);
